import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "settings-printer mt-1 mb-3"
};
var _hoisted_2 = {
  class: "mb-1"
};
var _hoisted_3 = {
  class: "item-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("settings.payment")), 1), _createVNode(_component_el_form, {
    model: _ctx.formData,
    "label-position": "top",
    "label-width": "120px",
    "hide-required-asterisk": true,
    class: "setting-items"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("button.complete-order-with-balance")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: _ctx.status ? 'primary' : 'default',
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.toggleStatus(true);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.enabled")), 1)];
                }),
                _: 1
              }, 8, ["type"]), _createVNode(_component_el_button, {
                type: !_ctx.status ? 'primary' : 'default',
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.toggleStatus(false);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.disabled")), 1)];
                }),
                _: 1
              }, 8, ["type"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model"])]);
}